import { Suspense, lazy } from 'react';

import { useNavigate } from 'react-router';

import { useLogout } from '../query/auth';
import { showConfirm } from './ui/confirm-dialog';
import { Button } from './ui/button';

const LogOut = lazy(() => import('lucide-react').then(mod => ({ default: mod.LogOut })));

const LogoutButton = () => {
  const navigate = useNavigate();
  const { mutate: logout } = useLogout();
  return (
    <Button
      variant="outline"
      size={'sm'}
      className="justify-start bg-transparent shadow flex-1"
      onClick={async () => {
        const result = await showConfirm({
          title: '로그아웃',
          description: '로그아웃 하시겠습니까?',
          variant: 'default',
        });
        if (result) {
          logout(null, {
            onSuccess: () => {
              navigate('/sign-in', { replace: true });
            },
          });
        }
      }}
    >
      <Suspense fallback={<div className="w-4 h-4" />}>
        <LogOut />
      </Suspense>
      로그아웃
    </Button>
  );
};

export default LogoutButton;
